import { withStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import { COLORS } from '../../utils/Application_Constants';

const ToolTipComponent = withStyles({
    tooltip: {
        color: COLORS.WHITE,
        backgroundColor: COLORS.TRUE_BLUE,
        fontSize: '12px',
        borderRadius: 0,
        width: '250px',
        padding: '10px',
    },
    arrow: {
        color: COLORS.TRUE_BLUE,
    },
})(Tooltip);

export default ToolTipComponent;
